// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: rtc/path_plan.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { RigActivitiesConfiguration } from "../atk/activities";
import { ScvAutonomyActivitiesConfiguration } from "../atk/autotractor";

export const protobufPackage = "carbon.rtc";

export enum Direction {
  DIRECTION_UNSPECIFIED = 0,
  CW = 1,
  CCW = 2,
  UNRECOGNIZED = -1,
}

export function directionFromJSON(object: any): Direction {
  switch (object) {
    case 0:
    case "DIRECTION_UNSPECIFIED":
      return Direction.DIRECTION_UNSPECIFIED;
    case 1:
    case "CW":
      return Direction.CW;
    case 2:
    case "CCW":
      return Direction.CCW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Direction.UNRECOGNIZED;
  }
}

export function directionToJSON(object: Direction): string {
  switch (object) {
    case Direction.DIRECTION_UNSPECIFIED:
      return "DIRECTION_UNSPECIFIED";
    case Direction.CW:
      return "CW";
    case Direction.CCW:
      return "CCW";
    case Direction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PathPlanConfiguration {
  doHeadlandFirst: boolean;
  rowHeadingDeg: number;
  headlandWidthM: number;
  turnDirection: Direction;
  /**
   * the number of passes to work the headland in; 273 is currently (2/27/2026)
   * a magic number which means "as many as the path planner lambda thinks it
   * needs".  will be deprecated soon.
   */
  numHeadlandPasses: number;
  /** @deprecated */
  combinedTurnRadiusM?: number | undefined;
  splitOnCenterPivots: boolean;
  flipRowOrder: boolean;
  workingOverlapM: number;
  toolSpeedMS: number;
  transitionSpeedMS: number;
  enableDebugRun?:
    | boolean
    | undefined;
  /** @deprecated */
  activities: ScvAutonomyActivitiesConfiguration | undefined;
  rigActivities: RigActivitiesConfiguration | undefined;
}

function createBasePathPlanConfiguration(): PathPlanConfiguration {
  return {
    doHeadlandFirst: false,
    rowHeadingDeg: 0,
    headlandWidthM: 0,
    turnDirection: 0,
    numHeadlandPasses: 0,
    combinedTurnRadiusM: undefined,
    splitOnCenterPivots: false,
    flipRowOrder: false,
    workingOverlapM: 0,
    toolSpeedMS: 0,
    transitionSpeedMS: 0,
    enableDebugRun: undefined,
    activities: undefined,
    rigActivities: undefined,
  };
}

export const PathPlanConfiguration: MessageFns<PathPlanConfiguration> = {
  encode(message: PathPlanConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.doHeadlandFirst !== false) {
      writer.uint32(8).bool(message.doHeadlandFirst);
    }
    if (message.rowHeadingDeg !== 0) {
      writer.uint32(21).float(message.rowHeadingDeg);
    }
    if (message.headlandWidthM !== 0) {
      writer.uint32(29).float(message.headlandWidthM);
    }
    if (message.turnDirection !== 0) {
      writer.uint32(32).int32(message.turnDirection);
    }
    if (message.numHeadlandPasses !== 0) {
      writer.uint32(40).int32(message.numHeadlandPasses);
    }
    if (message.combinedTurnRadiusM !== undefined) {
      writer.uint32(53).float(message.combinedTurnRadiusM);
    }
    if (message.splitOnCenterPivots !== false) {
      writer.uint32(56).bool(message.splitOnCenterPivots);
    }
    if (message.flipRowOrder !== false) {
      writer.uint32(64).bool(message.flipRowOrder);
    }
    if (message.workingOverlapM !== 0) {
      writer.uint32(77).float(message.workingOverlapM);
    }
    if (message.toolSpeedMS !== 0) {
      writer.uint32(81).double(message.toolSpeedMS);
    }
    if (message.transitionSpeedMS !== 0) {
      writer.uint32(89).double(message.transitionSpeedMS);
    }
    if (message.enableDebugRun !== undefined) {
      writer.uint32(104).bool(message.enableDebugRun);
    }
    if (message.activities !== undefined) {
      ScvAutonomyActivitiesConfiguration.encode(message.activities, writer.uint32(114).fork()).join();
    }
    if (message.rigActivities !== undefined) {
      RigActivitiesConfiguration.encode(message.rigActivities, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PathPlanConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePathPlanConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.doHeadlandFirst = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.rowHeadingDeg = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.headlandWidthM = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.turnDirection = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.numHeadlandPasses = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.combinedTurnRadiusM = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.splitOnCenterPivots = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.flipRowOrder = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.workingOverlapM = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.toolSpeedMS = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.transitionSpeedMS = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.enableDebugRun = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.activities = ScvAutonomyActivitiesConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.rigActivities = RigActivitiesConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PathPlanConfiguration {
    return {
      doHeadlandFirst: isSet(object.doHeadlandFirst)
        ? globalThis.Boolean(object.doHeadlandFirst)
        : isSet(object.do_headland_first)
        ? globalThis.Boolean(object.do_headland_first)
        : false,
      rowHeadingDeg: isSet(object.rowHeadingDeg)
        ? globalThis.Number(object.rowHeadingDeg)
        : isSet(object.row_heading_deg)
        ? globalThis.Number(object.row_heading_deg)
        : 0,
      headlandWidthM: isSet(object.headlandWidthM)
        ? globalThis.Number(object.headlandWidthM)
        : isSet(object.headland_width_m)
        ? globalThis.Number(object.headland_width_m)
        : 0,
      turnDirection: isSet(object.turnDirection)
        ? directionFromJSON(object.turnDirection)
        : isSet(object.turn_direction)
        ? directionFromJSON(object.turn_direction)
        : 0,
      numHeadlandPasses: isSet(object.numHeadlandPasses)
        ? globalThis.Number(object.numHeadlandPasses)
        : isSet(object.num_headland_passes)
        ? globalThis.Number(object.num_headland_passes)
        : 0,
      combinedTurnRadiusM: isSet(object.combinedTurnRadiusM)
        ? globalThis.Number(object.combinedTurnRadiusM)
        : isSet(object.combined_turn_radius_m)
        ? globalThis.Number(object.combined_turn_radius_m)
        : undefined,
      splitOnCenterPivots: isSet(object.splitOnCenterPivots)
        ? globalThis.Boolean(object.splitOnCenterPivots)
        : isSet(object.split_on_center_pivots)
        ? globalThis.Boolean(object.split_on_center_pivots)
        : false,
      flipRowOrder: isSet(object.flipRowOrder)
        ? globalThis.Boolean(object.flipRowOrder)
        : isSet(object.flip_row_order)
        ? globalThis.Boolean(object.flip_row_order)
        : false,
      workingOverlapM: isSet(object.workingOverlapM)
        ? globalThis.Number(object.workingOverlapM)
        : isSet(object.working_overlap_m)
        ? globalThis.Number(object.working_overlap_m)
        : 0,
      toolSpeedMS: isSet(object.toolSpeedMS)
        ? globalThis.Number(object.toolSpeedMS)
        : isSet(object.tool_speed_m_s)
        ? globalThis.Number(object.tool_speed_m_s)
        : 0,
      transitionSpeedMS: isSet(object.transitionSpeedMS)
        ? globalThis.Number(object.transitionSpeedMS)
        : isSet(object.transition_speed_m_s)
        ? globalThis.Number(object.transition_speed_m_s)
        : 0,
      enableDebugRun: isSet(object.enableDebugRun)
        ? globalThis.Boolean(object.enableDebugRun)
        : isSet(object.enable_debug_run)
        ? globalThis.Boolean(object.enable_debug_run)
        : undefined,
      activities: isSet(object.activities) ? ScvAutonomyActivitiesConfiguration.fromJSON(object.activities) : undefined,
      rigActivities: isSet(object.rigActivities)
        ? RigActivitiesConfiguration.fromJSON(object.rigActivities)
        : isSet(object.rig_activities)
        ? RigActivitiesConfiguration.fromJSON(object.rig_activities)
        : undefined,
    };
  },

  toJSON(message: PathPlanConfiguration): unknown {
    const obj: any = {};
    if (message.doHeadlandFirst !== false) {
      obj.doHeadlandFirst = message.doHeadlandFirst;
    }
    if (message.rowHeadingDeg !== 0) {
      obj.rowHeadingDeg = message.rowHeadingDeg;
    }
    if (message.headlandWidthM !== 0) {
      obj.headlandWidthM = message.headlandWidthM;
    }
    if (message.turnDirection !== 0) {
      obj.turnDirection = directionToJSON(message.turnDirection);
    }
    if (message.numHeadlandPasses !== 0) {
      obj.numHeadlandPasses = Math.round(message.numHeadlandPasses);
    }
    if (message.combinedTurnRadiusM !== undefined) {
      obj.combinedTurnRadiusM = message.combinedTurnRadiusM;
    }
    if (message.splitOnCenterPivots !== false) {
      obj.splitOnCenterPivots = message.splitOnCenterPivots;
    }
    if (message.flipRowOrder !== false) {
      obj.flipRowOrder = message.flipRowOrder;
    }
    if (message.workingOverlapM !== 0) {
      obj.workingOverlapM = message.workingOverlapM;
    }
    if (message.toolSpeedMS !== 0) {
      obj.toolSpeedMS = message.toolSpeedMS;
    }
    if (message.transitionSpeedMS !== 0) {
      obj.transitionSpeedMS = message.transitionSpeedMS;
    }
    if (message.enableDebugRun !== undefined) {
      obj.enableDebugRun = message.enableDebugRun;
    }
    if (message.activities !== undefined) {
      obj.activities = ScvAutonomyActivitiesConfiguration.toJSON(message.activities);
    }
    if (message.rigActivities !== undefined) {
      obj.rigActivities = RigActivitiesConfiguration.toJSON(message.rigActivities);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PathPlanConfiguration>, I>>(base?: I): PathPlanConfiguration {
    return PathPlanConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PathPlanConfiguration>, I>>(object: I): PathPlanConfiguration {
    const message = createBasePathPlanConfiguration();
    message.doHeadlandFirst = object.doHeadlandFirst ?? false;
    message.rowHeadingDeg = object.rowHeadingDeg ?? 0;
    message.headlandWidthM = object.headlandWidthM ?? 0;
    message.turnDirection = object.turnDirection ?? 0;
    message.numHeadlandPasses = object.numHeadlandPasses ?? 0;
    message.combinedTurnRadiusM = object.combinedTurnRadiusM ?? undefined;
    message.splitOnCenterPivots = object.splitOnCenterPivots ?? false;
    message.flipRowOrder = object.flipRowOrder ?? false;
    message.workingOverlapM = object.workingOverlapM ?? 0;
    message.toolSpeedMS = object.toolSpeedMS ?? 0;
    message.transitionSpeedMS = object.transitionSpeedMS ?? 0;
    message.enableDebugRun = object.enableDebugRun ?? undefined;
    message.activities = (object.activities !== undefined && object.activities !== null)
      ? ScvAutonomyActivitiesConfiguration.fromPartial(object.activities)
      : undefined;
    message.rigActivities = (object.rigActivities !== undefined && object.rigActivities !== null)
      ? RigActivitiesConfiguration.fromPartial(object.rigActivities)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
